import axios from '../utils/axios';
export const transactionCheck = async () => axios.get('user/checkPayment');
